import load from '@/types/models/load';
import settlement from '@/types/models/settlement';

export default {
  load,
  settlement,
};




// WEBPACK FOOTER //
// ./src/types/models/index.js